import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type { FieldInterface } from 'src/tpbp-configuration/mapper/mappingInterfaces'

export const esgDataFields: FieldInterface[] = [
  {
    key: 'esgSfdr',
    originKey: 'esg_sfdr',
    type: FIELD_TYPES.object,
    objectType: 'EsgCriteria',
    objectTypePath: 'src/services/people/peopleApiServiceRiskLevels.types',
  },
  {
    key: 'esgTaxonomy',
    originKey: 'esg_taxonomy',
    type: FIELD_TYPES.object,
    objectType: 'EsgCriteria',
    objectTypePath: 'src/services/people/peopleApiServiceRiskLevels.types',
  },
  {
    key: 'esgPai',
    originKey: 'esg_pai',
    type: FIELD_TYPES.object,
    isMultiple: false,
    objectType: 'PaiEsgCriteria',
    objectTypePath: 'src/services/people/peopleApiServiceRiskLevels.types',
  },
]

export const esgDataRelations = []
